let ROOT_URL = "https://hms.janio.asia/api";
let API_PRINT_TN = "https://api.janio.asia/api";

if (window.location.host.includes("staging") || window.location.host.includes("localhost")) {
  ROOT_URL = "https://hms.staging.janio.asia/api";
  API_PRINT_TN = "https://api.staging.janio.asia/api";
}

export { ROOT_URL, API_PRINT_TN };
